export default __webpack_public_path__ + "static/media/888tweetvideo.c7ba833e.mp4";